import React from 'react';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';

const CustomizedAxisTick = props => {
  const { x, y, stroke, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
        transform="rotate(-40)"
      >
        {payload.value}
      </text>
    </g>
  );
};

export default ({ data }) => (
  <BarChart
    width={500}
    height={300}
    data={data}
    margin={{
      top: 20,
      right: 30,
      left: 20,
      bottom: 10
    }}
  >
    <CartesianGrid strokeDasharray="3 3" />
    {/* <XAxis dataKey="name" height={80} tick={<CustomizedAxisTick />} /> */}
    <XAxis dataKey="name" tick={false} />
    <YAxis />
    <Tooltip />
    {/* <Legend /> */}
    <Bar dataKey="value" fill="#82ca9d" />
  </BarChart>
);
